<template>
  <div class="catalog">
    <div v-if="user.id">

      <div>
        <div class="row">
          <!--
          <div class="col-sm-3">

            <h1 class="h3 mb-4">Catalogo</h1>
            <ul class="list-group">
              <li class="list-group-item" v-for="price_list in price_lists" v-bind:key="price_list.id">
                <span class="form-check">
                  <input type="checkbox"  class="form-check-input" v-model="price_list.checked">
                  <span class="form-check-label"><strong>{{ price_list.code }}</strong> <small>{{ price_list.description}}</small></span>
                </span>    
              </li>
            </ul>
          
            <a class="btn btn-primary w-100 mt-4"  href="#" @click.prevent="getProducts()">Carica prodotti</a>

          </div>
          -->
          <div class="col-sm-12">
            <div class="row mb-4">
                <div class="col-sm-4">
                  <h1>Catalogo</h1>
                </div>
                <div class="col-sm-4">
                  <p class="mt-3">
                    <strong>{{ products.total ? products.total : 0 }}</strong> prodotti trovati 
                    <template  v-if="products.total > 0"> - Pagina <strong>{{ products.current_page }}</strong> di <strong>{{ products.last_page}}</strong></template>
                  </p>
                </div>
                <div class="col-sm-4">
                  <div class="input-group">
                    <input v-model="search" type="text" class="form-control" placeholder="Descrizione" v-on:keyup.enter="getProducts({ search: search })">
                    <button class="btn btn-primary" @click.prevent="getProducts({ search: search })">Cerca</button>
                  </div>
                </div>
              </div>


              <div class="row justify-content-center" v-if="products">
                <div class="col-sm-6 pb-3" v-for="product in products_filtered" v-bind:key="product.key">
                  <div class="card card-product h-100">
                    <div class="card-body row">
                      <div class="col-sm-6">
                        <CatalogImage :code="product.external_id" :key="product.external_id" :imgclass="'img-fluid'"/>
                      </div>
                      <div class="col-sm-6 d-flex align-items-center">

                        <div>
                          <span :title="product.id" class="badge badge-pill bg-dark">{{ product.external_id }}</span>
                          <br>
                          <!--
                          <small class="ms-1">{{ product.categories.filter( function( item ){ return item.enabled; } ).map( function( item ){ return item.description; } ).join(' - ') }}</small>
                          -->
                          
                          <div class="h6 my-3">{{ product.description }}</div>
                        </div>
                      </div>
                    </div>
                    
                    
                    <div class="card-footer">
                      
                          <div class="text-end">
                              <div class="btn-group" role="group" aria-label="Azioni prodotto">
                                <a class="btn btn-secondary btn-lg" target="_blank" :href="'https://docs.coccatoemezzetti.com/pagine/PDF_cat.php?art=' + product.external_id">
                                  <i class="bi bi-file-pdf"></i>
                                </a>
                                <button  @click="setCurrentProduct( product )" class="btn btn-primary btn-lg"  data-bs-toggle="modal" data-bs-target="#productModal">
                                  <i class="bi bi-info-circle"></i>
                                </button>
                              
                              </div>
                            </div>

                    </div>
                  </div>
                </div>
              </div>

           


              <div class="paginator row my-5"  v-if="products.total > 0">
                <div class="col-sm-4 offset-sm-4 text-center">
                  <div class="input-group">
                    <button class="btn btn-outline-secondary" :disabled="products.current_page == 1" @click.prevent="getProducts({ page: 1, search: search })" type="button"><i class="bi-chevron-double-left" ></i></button>
                    <button class="btn btn-outline-secondary" :disabled="products.current_page <= 1" @click.prevent="getProducts({ page: products.current_page - 1, search: search })" type="button"><i class="bi-chevron-left" ></i></button>
                    <select v-model="products.current_page" class="form-select text-center border-secondary" @change="getProducts({ page: products.current_page, search: search })">
                      <option v-for="p in parseInt(products.last_page)" :key="p" :value="p">{{ p }}</option>
                    </select>
                    <button class="btn btn-outline-secondary" :disabled="products.current_page >= products.last_page"  @click.prevent="getProducts({ page: products.current_page + 1, search: search })" type="button"><i class="bi-chevron-right"></i></button>
                    <button class="btn btn-outline-secondary" :disabled="products.current_page == products.last_page"  @click.prevent="getProducts({ page: products.last_page, search: search })" type="button"><i class="bi-chevron-double-right"></i></button>
                  </div>
                  <small>di {{ products.last_page }} pagine - {{ products.total ? products.total : 0 }} risultati</small>
                </div>
              </div>
              
                

          </div>
        </div>

      
        
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src


import CmShopsMixin from '../mixins/CmShopsMixin'
import CatalogImage from '../components/CatalogImage'


export default {
  mixins: [ CmShopsMixin ],
  components: { CatalogImage },
  name: 'Catalog',
  data: () => {
		return {
      search: '',
			products: {},
      
			
		}
	},
  mounted: function(){
    
    
    this.getProducts();
  },
  methods:{
    
   
    
    getProducts: function( post_data ){
      var self = this;

      

      
      if(post_data == undefined  ){
        if(!post_data)
          var post_data = {};
      
      } 

      // passo l'id dell'cliente corrente per sapere il prezzo corrente
      
      if(this.user.profiles[0] != undefined){
        post_data.current_price_list_id = this.user.profiles[0].price_list_id;
        post_data.customer_external_id = this.user.external_id;
      }
      

      this.api.post( 'catalog/getProducts' , post_data)
      .then(function (response) {
          if(response.data.products){
            self.notification.success( 'Prodotti caricati correttamente' );
            self.products = response.data.products;
          }
      })


    },
    
    
  },
  computed:{
    products_filtered: function(){
        return this.products.data;
    }
  }
  
}
</script>
